/** @flow */

import type { AbsencesState } from "./types";

export const initialState: AbsencesState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  alerts: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  modals: {
    transferAbsenceConfirmation: {
      visible: false,
    },
    transferAbsence: {
      visible: false,
      editing: false,
      absence: null,
    },
    addAbsence: {
      visible: false,
      editing: false,
      absence: null,
    },
    alertsTriggered: {
      visible: false,
    },
    shiftPattern: {
      visible: false,
    },
    interaction: {
      visible: false,
      data: null,
    },
    additionalInfo: {
      visible: false,
      data: null,
    },
    addAbsenceDocument: {
      visible: false,
    },
    deleteAbsenceDocument: {
      visible: false,
      documentId: null,
    },
    absenceNotification: {
      visible: false,
      notification: null,
    },
    managerNotes: {
      editMode: false,
      visible: false,
      data: null,
    },
    deleteManagerNote: {
      visible: false,
      note: null,
    },
    rtwInterview: {
      visible: false,
    },
  },
  employeeNonCancelledAbsences: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  absenceNoteTypes: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  absenceDetails: {
    requestsInProgress: 0,
  },
  absenceShiftPattern: [],
  absenceShiftPatternOptions: null,
  absencesSchema: null,
  interactions: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  additionalInfo: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  absenceStatistics: null,
  absenceDocuments: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  revisionHistory: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  employeeSMSMessages: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  managerNotes: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  absenceNotifications: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  managerNotesSchema: null,
  captureAbsenceBankHolidays: null,
  bankHolidays: [],
  absenceCancelReasons: [],
};

export default initialState;
